import { Address } from './address';

export interface CheckoutRequestAttributes {
  payment?: {
    card: {
      token: string;
    };
  };

  customer?: CustomerDetails;
  marketingCommunications?: boolean;
}

export interface CustomerDetails {
  email: string;
  name?: string;
  address?: Address;
  delivery_address?: string;
}

export class CheckoutRequest implements CheckoutRequestAttributes {
  payment: {
    card: {
      token: string;
    };
  };

  customer: CustomerDetails;
  marketingCommunications: boolean;

  constructor(attributes?: CheckoutRequestAttributes) {
    this.payment = {
      card: {
        token: ''
      }
    };
    this.customer = {
      email: ''
    };
    this.marketingCommunications = false;

    if (attributes) {
      this.payment = attributes.payment || this.payment;
      this.customer = attributes.customer || this.customer;
      this.marketingCommunications = attributes.marketingCommunications || this.marketingCommunications;
    }
  }

  get address(): Address {
    return this.customer.address!;
  }

  toStripe() {
    return {
      name: this.customer.name,
      email: this.customer.email,
      address_line1: this.address.address1,
      address_line2: this.address.address2,
      address_city: this.address.city,
      address_state: this.address.state_name,
      address_zip: this.address.zip_code
    };
  }

  toBeachy() {
    return {
      payment: {
        ...this.payment,
        marketing_communications: this.marketingCommunications,
      },
      customer: {
        name: this.customer.name,
        email: this.address.email,
        phone: this.address.phone,
        delivery_address: this.customer.delivery_address,
      },
      address: {
        ...this.address
      }
    } as CheckoutRequestAttributes;
  }
}

